import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import Navigation from '@/components/Navigation.vue'; // @ is an alias to /src
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcCreateRecord, { BcNRDialog } from '@/components/CreateRecord.vue';
// @ts-ignore
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
let Home = class Home extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.drawer = false;
        this.bottomNav = true;
        this.userMenu = false;
        this.pageLoading = { dispenrecords: false, mailfunctionrecords: false };
        this.itemsDailyDisp = [];
        this.itemsMalfunction = [];
        this.dlgNewRecord = new BcNRDialog();
        this.dlgResetPass = new CBcDialog(new CBcDialogForm());
        const that = this;
    }
    mounted() {
        const that = this;
        that.getDispenDail();
        that.getMalfunctionDaily();
        that.fetchDeviceSerialList();
        that.fetchDevices();
        that.fetchDeviceModeCatalog();
    }
    dlgResetPassDisplay() {
        const that = this;
        that.dlgResetPass.form = {
            password: '',
            password2: '',
            showNewPass: false,
            showPass: false,
        };
        that.dlgResetPass.displayText = false;
        that.dlgResetPass.negative.text = '取消';
        that.dlgResetPass.positive.isText = false;
        that.dlgResetPass.title = '修改密码';
        that.dlgResetPass.fullscreen = false;
        that.dlgResetPass.persistent = true;
        that.dlgResetPass.autoClose = false;
        that.dlgResetPass.rejectedAction = () => {
            that.dlgResetPass.visible = false;
            that.dlgResetPass.form = {};
        };
        that.dlgResetPass.acceptedAction = async () => {
            try {
                const d = await that.axios.post('/api/users/password/reset/' + that.userInfo.id, {
                    oldPass: that.dlgResetPass.form.password,
                    newPass: that.dlgResetPass.form.password2,
                });
                that.snackbar.success('密码修改成功.');
                that.dlgResetPass.visible = false;
            }
            catch (e) {
                console.log('error of reset pass:', e);
                that.snackbar.error(e && (e.result || e.error) || '密码修改失败.' + e.toString());
            }
        };
        that.dlgResetPass.width = /^xs$|^sm$/i.test(that.$vuetify.breakpoint.name) ? '90%' : '50%';
        that.dlgResetPass.visible = true;
    }
    copyInfo(type, item) {
        const that = this;
        const str = type === 'dispen' ? `${item.hospital ? `${item.hospital}\n` : ''}${item.records.map((ri) => `${ri.dept || ''} ${ri.device}\n${ri.subItems.map((si) => si.hint).join('\n')}`).join('\n')}` : `${item.hospital ? `${item.hospital}\n` : ''}${item.records.map((ri) => `${ri.dept || ''} ${ri.device}\n${ri.subItems.map((si, sii) => `${sii + 1}、${si.description}${si.reason || ''}`).join('\n')}`).join('\n')}`;
        that.$clipboard(str);
        that.snackbar.info('内容已复制到剪贴板.');
    }
    async getDispenDail() {
        const that = this;
        that.pageLoading.dispenrecords = true;
        try {
            const d = await that.axios.get('/api/recipels/manual/dailyreport');
            that.pageLoading.dispenrecords = false;
            that.itemsDailyDisp = d.data.result;
            // that.setDispenDail(d.data.result)
        }
        catch (e) {
            that.pageLoading.dispenrecords = false;
            that.snackbar.error('获取新增设备记录信息过程出错:' + (e && e.info || e.result || e.error));
        }
    }
    // setDispenDail(resultData: any) {
    //     const that: any = this
    //     that.itemsDailyDisp = [];
    //     if (!resultData || resultData.length === 0) {
    //         return false;
    //     }
    //     // 这里组装成页面需要的格式，就不用再做转换了
    //     resultData.forEach((item: any) => {
    //         var hModel = {
    //             hospital: item.hospital,
    //             recorder: item.recorder,
    //             records: [] as Array<any>
    //         }
    //         // 内镜柜、呼吸训练、清洗机需要合并和处理
    //         item.records.forEach((record: any) => {
    //             record.deviceCategory = BcCommon.getDeviceCategory(record.deviceType, record.deviceMode)
    //             if (record.deviceCategory == EBcDeviceType.Ampul ||
    //                 record.deviceCategory == EBcDeviceType.Xilin ||
    //                 record.deviceCategory == EBcDeviceType.Auto ||
    //                 record.deviceCategory == EBcDeviceType.Liquid ||
    //                 record.deviceCategory == EBcDeviceType.PreDissolve) {
    //                 hModel.records.push(record);
    //                 return;
    //             }
    //             // 这些小设备，一个医院一个科室一种设备型号汇总展示，不用精确具体设备，如果要展示把再上面逻辑中加入条件即可，
    //             // 如加入清洗机 || record.deviceCategory == EBcDeviceType.CleaningMachine
    //             // 医院名称  空格 科室名称  设备型号
    //             record.device = `${record.deviceType} (${record.deviceMode})`;
    //             var fRecord = hModel.records.find((o: any) => o.dept == record.dept && o.deviceCategory == record.deviceCategory && o.deviceMode == record.deviceMode);
    //             if (!fRecord) {
    //                 // 首次不存在时直接加入到集合
    //                 hModel.records.push(record);
    //                 return;
    //             }
    //             // 存在同类型设备时汇总
    //             record.subItems.forEach((sitem: any) => {
    //                 const fItem = fRecord.subItems.find((o: any) => o.date == sitem.date);
    //                 if (fItem) {
    //                     fItem.total = Number(fItem.total) + Number(sitem.total)
    //                     fItem.success = Number(fItem.success) + Number(sitem.success)
    //                     fItem.faile = Number(fItem.faile) + Number(sitem.faile)
    //                 } else {
    //                     fRecord.subItems.push(sitem)
    //                 }
    //             })
    //         })
    //         // 组织页面展示话术
    //         hModel.records.forEach((record: any) => {
    //             record.subItems.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime());
    //             record.subItems.forEach((sitem: any) => {
    //                 if (record.deviceCategory == EBcDeviceType.Ampul ||
    //                     record.deviceCategory == EBcDeviceType.Xilin ||
    //                     record.deviceCategory == EBcDeviceType.Auto ||
    //                     record.deviceCategory == EBcDeviceType.Liquid ||
    //                     record.deviceCategory == EBcDeviceType.PreDissolve) {
    //                     sitem.hint = `${sitem.date}，临床配药${sitem.total}副，${Number(sitem.faile) !== 0 ? ('失败' + sitem.faile + '副') : '都成功'}${sitem.bottles ? ('，共' + sitem.bottles + '瓶') : ''}` + '。';
    //                     return;
    //                 }
    //                 if (record.deviceCategory == EBcDeviceType.BreathTrain) {
    //                     sitem.hint = `${sitem.date}，共训练${sitem.total}人，${Number(sitem.faile) !== 0 ? ('未达标' + sitem.faile + '人') : '都达标'}。`;
    //                     return;
    //                 }
    //                 if (record.deviceCategory == EBcDeviceType.CleaningMachine) {
    //                     sitem.hint = `${sitem.date}，共清洗${sitem.total}条，${Number(sitem.faile) !== 0 ? ('失败' + sitem.faile + '条') : '都成功'}${(sitem.remark ? '，' + sitem.remark : '')}。`;
    //                     return;
    //                 }
    //                 if (record.deviceCategory == EBcDeviceType.EndoscopeArk) {
    //                     sitem.hint = `${sitem.date}，共存取${sitem.total}次，存入${sitem.success}次，取出${sitem.faile}次。`;
    //                     return;
    //                 }
    //             })
    //         });
    //         that.itemsDailyDisp.push(hModel)
    //     })
    // }
    async getMalfunctionDaily() {
        const that = this;
        that.pageLoading.mailfunctionrecords = true;
        try {
            const d = await that.axios.get('/api/malfunctions/dailyreport');
            that.pageLoading.mailfunctionrecords = false;
            that.itemsMalfunction = d.data.result;
        }
        catch (e) {
            that.pageLoading.mailfunctionrecords = false;
            that.snackbar.error('获取新增设备记录信息过程出错:' + (e && e.info || e.result || e.error));
        }
    }
    newRecordSaved(error, msg) {
        const that = this;
        if (!error) {
            that.getDispenDail();
            that.getMalfunctionDaily();
        }
    }
};
__decorate([
    Getter
], Home.prototype, "isThirdApp", void 0);
__decorate([
    Getter
], Home.prototype, "isDingTalk", void 0);
__decorate([
    Getter
], Home.prototype, "userInfo", void 0);
__decorate([
    Action
], Home.prototype, "fetchDevices", void 0);
__decorate([
    Action
], Home.prototype, "fetchDeviceSerialList", void 0);
__decorate([
    Action
], Home.prototype, "fetchDeviceModeCatalog", void 0);
Home = __decorate([
    Component({
        data: () => ({
            left: false,
        }),
        props: {
            source: String,
        },
        components: {
            BcSnackbar,
            BcDialog,
            Navigation,
            BcCreateRecord,
        },
        methods: {
            navigSelected(val) {
                const that = this;
                that.$router.push({ path: val.path });
            },
            async logout() {
                const that = this;
                that.$store.dispatch('logout');
                that.$router.push({ path: '/login' });
            },
        },
        watch: {},
    })
], Home);
export default Home;
